export const BIDS_STATUSES = [
    {
        id: 13,
        name: 'На подписании',
    },
    {
        id: 14,
        name: 'Подписан',
    },
]
